import Vue from 'vue';
// @ts-ignore
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/src/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#374afb',
        secondary: '#1F1E2E',
        ternary: '#181824',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
    lang: {
      locales: { fr },
      current: 'fr',
    },
});
